import {TranslateService} from '../_services/translate.service';
import Swal from 'sweetalert2';

export function getNewVersionAlert(
  translateService: TranslateService
): Function {
  return () => {
    Swal.fire({
      title:  translateService.translate('dashboard_new_version'),
      icon: 'info',
      html:
        translateService.translate('dashboard_new_version_description'),
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      reverseButtons: true,
      cancelButtonText:
        translateService.translate('dashboard_new_version_cancel'),
      confirmButtonText:
        translateService.translate('dashboard_new_version_ok'),
    }).then((result) => {

      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
};
